(function() {
  var BaseHandler, BaseOutput, ChartOutput,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  BaseHandler = App.loadClass("core::reports/BaseHandler");

  BaseOutput = App.loadClass("core::reports/BaseOutput");

  ChartOutput = App.loadClass("core::reports/ChartOutput");

  exports.ReportsNBalanceSubHandler = (function(superClass) {
    extend(ReportsNBalanceSubHandler, superClass);

    function ReportsNBalanceSubHandler() {
      this.getDataSummary = bind(this.getDataSummary, this);
      this.getDataDetail = bind(this.getDataDetail, this);
      return ReportsNBalanceSubHandler.__super__.constructor.apply(this, arguments);
    }

    ReportsNBalanceSubHandler.prototype.init = function() {
      this.hasPrint = false;
      this.parent.dialog.find('.print-btn').hide();
      this.sourceUrl = 'backend/grower/reports/n-balance/output/detail';
      this.layoutUrl = 'backend/grower/reports/n-balance/chart';
      this.filterUrl = 'backend/grower/reports/n-balance/filters';
      this.layoutSelector = "#reports_n_balance_tab";
      $('.sidebar_content').find('.view-field-group-button-container').removeClass('hide');
      $('.sidebar_content').find('#view-field-group-button').prop('disabled', true);
      this.initFilters();
      this.borderWidth = 2;
      this.hoverBorderWidth = 3;
      return this.fieldGroup = null;
    };

    ReportsNBalanceSubHandler.prototype.afterLoadLayout = function() {
      return ReportsNBalanceSubHandler.__super__.afterLoadLayout.call(this);
    };

    ReportsNBalanceSubHandler.prototype.initFilters = function() {
      this.disableAllFilterGroups();
      this.parent.filters.importGroup({
        name: 'N Balance Report Filters',
        display_name: 'Report Filters',
        filters: [
          {
            name: 'nbalance_years',
            display_name: 'Year',
            control_type: 'single_dropdown',
            deletable: false,
            auto_select_first: true
          }, {
            name: 'nbalance_crops',
            display_name: 'Crop',
            control_type: 'single_dropdown',
            deletable: false,
            auto_select_only_value: true,
            auto_select_first: true
          }, {
            name: 'nbalance_previous_crops',
            display_name: 'Previous Crop',
            control_type: 'dropdown',
            deletable: true
          }, {
            name: 'nbalance_distances',
            display_name: 'Distance',
            control_type: 'single_dropdown',
            values: [
              {
                key: '50',
                value: 'Within 50 miles'
              }, {
                key: '100',
                value: 'Within 100 miles'
              }, {
                key: '150',
                value: 'Within 150 miles'
              }, {
                key: '200',
                value: 'Within 200 miles'
              }, {
                key: '250',
                value: 'Within 250 miles'
              }, {
                key: '300',
                value: 'Within 300 miles'
              }, {
                key: '350',
                value: 'Within 350 miles'
              }
            ]
          }, {
            name: 'nbalance_operation_sizes',
            display_name: 'Operation Size',
            values: [
              {
                key: '0-250',
                value: '0 - 250 acres'
              }, {
                key: '250-2500',
                value: '250 - 2500 acres'
              }, {
                key: '2500-5000',
                value: '2500 - 5000 acres'
              }, {
                key: '5000-',
                value: '5000+ acres'
              }
            ]
          }, {
            name: 'nbalance_partners',
            display_name: 'Partner',
            control_type: 'dropdown',
            deletable: true
          }, {
            name: 'nbalance_fields',
            display_name: 'Field',
            control_type: 'dropdown',
            deletable: true
          }, {
            name: 'field_groups',
            display_name: 'Field Group',
            control_type: 'single_dropdown',
            deletable: false,
            auto_select_first: true,
            auto_select_only_value: true,
            auto_clear_unavailable: true
          }, {
            name: 'irrigation_type',
            display_name: 'Irrigation Type',
            control_type: 'option',
            deletable: true,
            values: [
              {
                key: 'dryland',
                value: 'Dryland'
              }, {
                key: 'irrigated',
                value: 'Irrigated'
              }
            ]
          }, {
            name: 'nbalance_nitrogen_rates',
            display_name: 'Nitrogen Rate',
            control_type: 'dropdown',
            deletable: true,
            values: [
              {
                key: '0-50',
                value: '0 - 50 lbs/ac'
              }, {
                key: '50-100',
                value: '50 - 100 lbs/ac'
              }, {
                key: '100-150',
                value: '100 - 150 lbs/ac'
              }, {
                key: '150-200',
                value: '150 - 200 lbs/ac'
              }, {
                key: '200-250',
                value: '200 - 250 lbs/ac'
              }, {
                key: '250-300',
                value: '250 - 300 lbs/ac'
              }, {
                key: '300-350',
                value: '300 - 350 lbs/ac'
              }
            ]
          }, {
            name: 'nbalance_components',
            display_name: 'N Component'
          }, {
            name: 'output_type',
            display_name: 'Output Type',
            control_type: 'option',
            deletable: false,
            values: [
              {
                key: 'detail',
                value: 'Detail'
              }, {
                key: 'summary',
                value: 'Summary'
              }
            ],
            selected_values: [
              {
                key: 'summary',
                value: 'Summary'
              }
            ]
          }
        ]
      });
      return this.setDefaultsAndRun(0, 0, 0, {}, 'up', false);
    };

    ReportsNBalanceSubHandler.prototype.destroy = function() {
      this.parent.filters.removeGroup('N Balance Report Filters');
      this.parent.filters.enableGroup("Report Filters");
      this.parent.dialog.find('.excel-btn').addClass('hidden');
      this.parent.dialog.find('.info-popover').addClass('hide');
      return ReportsNBalanceSubHandler.__super__.destroy.call(this);
    };

    ReportsNBalanceSubHandler.prototype.getDataDetail = function() {
      $('.sidebar_content').find('#view-field-group-button').prop('disabled', true);
      $('.sidebar_content').find('#view-field-group-button-spinner').removeClass('hide');
      return $.get('backend/grower/reports/n-balance/output/detail', {
        query: this.filters
      }).then((function(_this) {
        return function(data) {
          var componentsFilters, coverCropBorderColors, datasets, fertilizerBorderColors, grainBorderColors, legumeBorderColors, manureBorderColors, records, residueBorderColors, youIndex;
          $('.sidebar_content').find('#view-field-group-button-spinner').addClass('hide');
          if (data.status === 'error') {
            _this.parent.msg.message_writer(data.status, data.message);
            return;
          }
          $('.sidebar_content').find('#view-field-group-button').prop('disabled', false);
          data = JSON.parse(data);
          data.fieldGroup.field_group = _this.parent.filters.jsonize().filters.field_groups[0].value;
          _this.fieldGroup = data.fieldGroup;
          records = _(data.reportData).map(function(record) {
            record.score = record.fertilizer_score + record.manure_score + record.cover_crop_score - record.grain_score - record.residue_score;
            return record;
          }).orderBy('score', 'desc').value();
          youIndex = _.findIndex(records, {
            id: 'You'
          });
          fertilizerBorderColors = Array(records.length).fill('#bdbdbd');
          fertilizerBorderColors.splice(youIndex, 1, '#00b0f0');
          manureBorderColors = Array(records.length).fill('#9871a8');
          manureBorderColors.splice(youIndex, 1, '#00b0f0');
          coverCropBorderColors = Array(records.length).fill('#498fbf');
          coverCropBorderColors.splice(youIndex, 1, '#00b0f0');
          grainBorderColors = Array(records.length).fill('#e3c946');
          grainBorderColors.splice(youIndex, 1, '#00b0f0');
          residueBorderColors = Array(records.length).fill('#ef8511');
          residueBorderColors.splice(youIndex, 1, '#00b0f0');
          legumeBorderColors = Array(records.length).fill('#00AD50');
          legumeBorderColors.splice(youIndex, 1, '#00b0f0');
          datasets = [
            {
              label: 'Fertilizer (+)',
              data: _.map(records, 'fertilizer_score'),
              fill: false,
              backgroundColor: '#bdbdbd',
              borderColor: fertilizerBorderColors,
              borderWidth: _this.borderWidth,
              hoverBorderWidth: _this.hoverBorderWidth,
              stack: 'N In'
            }, {
              label: 'Manure (+)',
              data: _.map(records, 'manure_score'),
              fill: false,
              backgroundColor: '#9871a8',
              borderColor: manureBorderColors,
              borderWidth: _this.borderWidth,
              hoverBorderWidth: _this.hoverBorderWidth,
              stack: 'N In'
            }, {
              label: 'Cover Crop (+)',
              data: _.map(records, 'cover_crop_score'),
              fill: false,
              backgroundColor: '#498fbf',
              borderColor: coverCropBorderColors,
              borderWidth: _this.borderWidth,
              hoverBorderWidth: _this.hoverBorderWidth,
              stack: 'N In'
            }, {
              label: 'Grain (-)',
              data: _.map(records, 'grain_score'),
              fill: false,
              backgroundColor: '#e3c946',
              borderColor: grainBorderColors,
              borderWidth: _this.borderWidth,
              hoverBorderWidth: _this.hoverBorderWidth,
              stack: 'N Out'
            }, {
              label: 'Residue (-)',
              data: _.map(records, 'residue_score'),
              fill: false,
              backgroundColor: '#ef8511',
              borderColor: residueBorderColors,
              borderWidth: _this.borderWidth,
              hoverBorderWidth: _this.hoverBorderWidth,
              stack: 'N Out'
            }
          ];
          if (_.filter(records, 'legume_score').length > 0) {
            datasets.unshift({
              label: 'Soybean (+)',
              data: _.map(records, 'legume_score'),
              fill: false,
              backgroundColor: '#00AD50',
              borderColor: legumeBorderColors,
              borderWidth: _this.borderWidth,
              hoverBorderWidth: _this.hoverBorderWidth,
              stack: 'N In'
            });
          }
          componentsFilters = _this.parent.filters.jsonize().filters.nbalance_components;
          if (componentsFilters.length > 0) {
            if (!_.find(componentsFilters, {
              key: 'fertilizer'
            })) {
              _.remove(datasets, {
                label: 'Fertilizer (+)'
              });
            }
            if (!_.find(componentsFilters, {
              key: 'manure'
            })) {
              _.remove(datasets, {
                label: 'Manure (+)'
              });
            }
            if (!_.find(componentsFilters, {
              key: 'cover_crop'
            })) {
              _.remove(datasets, {
                label: 'Cover Crop (+)'
              });
            }
            if (!_.find(componentsFilters, {
              key: 'grain'
            })) {
              _.remove(datasets, {
                label: 'Grain (-)'
              });
            }
            if (!_.find(componentsFilters, {
              key: 'residue'
            })) {
              _.remove(datasets, {
                label: 'Residue (-)'
              });
            }
            if (!_.find(componentsFilters, {
              key: 'soybean'
            })) {
              _.remove(datasets, {
                label: 'Soybean (+)'
              });
            }
          }
          return {
            data: {
              labels: _.map(records, 'id'),
              datasets: datasets
            },
            options: {
              legend: {
                display: true,
                position: 'bottom'
              }
            }
          };
        };
      })(this));
    };

    ReportsNBalanceSubHandler.prototype.getDataSummary = function() {
      $('.sidebar_content').find('#view-field-group-button').prop('disabled', true);
      $('.sidebar_content').find('#view-field-group-button-spinner').removeClass('hide');
      return $.get('backend/grower/reports/n-balance/output/detail', {
        query: this.filters
      }).then((function(_this) {
        return function(data) {
          var backgroundColors, borderColors, componentsFilters, datasets, records;
          $('.sidebar_content').find('#view-field-group-button-spinner').addClass('hide');
          if (data.status === 'error') {
            _this.parent.msg.message_writer(data.status, data.message);
            return;
          }
          data = JSON.parse(data);
          data.fieldGroup.field_group = _this.parent.filters.jsonize().filters.field_groups[0].value;
          _this.fieldGroup = data.fieldGroup;
          $('.sidebar_content').find('#view-field-group-button').prop('disabled', false);
          componentsFilters = _this.parent.filters.jsonize().filters.nbalance_components;
          records = _(data.reportData).map(function(record) {
            record.score = 0;
            if (componentsFilters.length === 0 || _.find(componentsFilters, {
              key: 'fertilizer'
            })) {
              record.score += record.fertilizer_score;
            }
            if (componentsFilters.length === 0 || _.find(componentsFilters, {
              key: 'manure'
            })) {
              record.score += record.manure_score;
            }
            if (componentsFilters.length === 0 || _.find(componentsFilters, {
              key: 'cover_crop'
            })) {
              record.score += record.cover_crop_score;
            }
            if ((componentsFilters.length === 0 || _.find(componentsFilters, {
              key: 'soybean'
            })) && (record.legume_score != null)) {
              record.score += record.legume_score;
            }
            record.score -= record.grain_score + record.residue_score;
            record.score = +record.score.toFixed(2);
            return record;
          }).orderBy('score', 'desc').value();
          backgroundColors = _.map(records, function(record) {
            if (record.score < 25 || record.score > 75) {
              return 'rgba(207, 27, 27, 0.6)';
            }
            return 'rgba(29, 139, 50, 0.6)';
          });
          borderColors = _.map(records, function(record) {
            if (record.id === 'You') {
              return '#00b0f0';
            }
            if (record.score < 25 || record.score > 75) {
              return '#d71b07';
            }
            return '#1d8b32';
          });
          datasets = [
            {
              label: 'Score',
              data: _.map(records, 'score'),
              fill: false,
              backgroundColor: backgroundColors,
              borderColor: borderColors,
              borderWidth: _this.borderWidth,
              hoverBorderWidth: _this.hoverBorderWidth
            }
          ];
          return {
            data: {
              labels: _.map(records, 'id'),
              datasets: datasets
            },
            options: {
              legend: {
                display: false
              }
            }
          };
        };
      })(this));
    };

    ReportsNBalanceSubHandler.prototype.beforeApply = function() {
      var filters, firstLoad, ref, ref1, ref2, ref3, xAxes, yAxes;
      filters = this.parent.filters.jsonize();
      firstLoad = this.currentOutput == null;
      if (filters.filters.output_type[0].key === 'detail') {
        if (!((this.currentOutput != null) && ((ref = this.parent.appliedFilters) != null ? ref.filters.output_type[0].key : void 0) === 'detail')) {
          xAxes = [
            {
              stacked: true,
              scaleLabel: {
                display: true,
                labelString: 'Anonymous Grower ID',
                fontSize: 20
              }
            }
          ];
          yAxes = [
            {
              stacked: true,
              scaleLabel: {
                display: true,
                labelString: 'N Inputs (+) and N Outputs (-) (lbs/ac)',
                fontSize: 20
              }
            }
          ];
          if ((ref1 = this.currentOutput) != null) {
            ref1.destroy();
          }
          this.currentOutput = new ChartOutput(this, this.parent, this.sourceUrl, 'bar', xAxes, yAxes, {}, this.getDataDetail);
        }
      } else {
        if (!((this.currentOutput != null) && ((ref2 = this.parent.appliedFilters) != null ? ref2.filters.output_type[0].key : void 0) === 'summary')) {
          xAxes = [
            {
              scaleLabel: {
                display: true,
                labelString: 'N Balance (N lbs/ac)',
                fontSize: 20
              }
            }
          ];
          yAxes = [
            {
              scaleLabel: {
                display: true,
                labelString: 'Grower Rank',
                fontSize: 20
              }
            }
          ];
          if ((ref3 = this.currentOutput) != null) {
            ref3.destroy();
          }
          this.currentOutput = new ChartOutput(this, this.parent, this.sourceUrl, 'horizontalBar', xAxes, yAxes, {
            plugins: {
              lineAtValues: [
                {
                  value: 25,
                  color: '#ffc000',
                  width: 3
                }, {
                  value: 75,
                  color: '#ffc000',
                  width: 3
                }
              ]
            }
          }, this.getDataSummary);
        }
      }
      return firstLoad;
    };

    return ReportsNBalanceSubHandler;

  })(BaseHandler);

}).call(this);
